import { render, staticRenderFns } from "./PrintedContainerBasic.vue?vue&type=template&id=68882794&scoped=true"
import script from "./PrintedContainerBasic.vue?vue&type=script&lang=js"
export * from "./PrintedContainerBasic.vue?vue&type=script&lang=js"
import style0 from "./PrintedContainerBasic.vue?vue&type=style&index=0&id=68882794&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68882794",
  null
  
)

export default component.exports